<template>
  <div class="error__wrapper full-width-section">
    <div class="error__container">
      <h2 class="error__title main-title">
        404 – Page Not Found
      </h2>
      <p class="error__text text-body">
        It looks like the page you’re looking for doesn't exist or has moved.
      </p>

      <div class="error__links-wrapper text-body-sm">
        <p>
          Access the
          <a-link :to="fmIntelligenceUrl">Finance Magnates Intelligence</a-link>
          Page
        </p>
        <p>
          Need help? Our team is here for you.
          <a-link :to="fmContactUsUrl" :open-in-new-tab="true"
            >Contact Us.</a-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  layout: 'empty',
  head() {
    return this.$generateMetaTags()
  },
  data() {
    return {
      fmIntelligenceUrl: this.$helper.generateFmUrl('/intelligence/', this),
      fmContactUsUrl: this.$helper.generateFmUrl('/contact-us/', this)
    }
  }
}
</script>

<style lang="scss" scoped>
.error__wrapper {
  position: relative;

  .error__container {
    max-width: $desktop-container;

    $text-align: (
      $above-desktop-xl: center,
      $mobile: left
    );

    $padding: (
      $above-desktop-xl: 0 $padding-x-desktop-full-hd 96px,
      $desktop-md: 0 $padding-x-desktop-md 64px,
      $mobile: 0 $padding-x-mobile 32px
    );

    @include setStyleByBreakpoint('padding', $padding);
    @include setStyleByBreakpoint('text-align', $text-align);
  }

  .error__title {
    color: $c--white;

    $font-size: (
      $desktop-md: 48px,
      $mobile: 36px
    );

    $line-height: (
      $desktop-md: 60px,
      $mobile: 44px
    );

    @include setStyleByBreakpoint('line-height', $line-height);
    @include setStyleByBreakpoint('font-size', $font-size);
  }

  .error__text {
    color: $c--white;

    $margin-top: (
      $above-desktop-xl: 16px,
      $desktop-md: 8px
    );

    $font-size: (
      $mobile: 14px
    );

    $line-height: (
      $mobile: 20px
    );

    @include setStyleByBreakpoint('line-height', $line-height);
    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .error__links-wrapper {
    display: flex;
    justify-content: center;

    $flex-direction: (
      $desktop-md: column
    );

    $margin-top: (
      $above-desktop-xl: 16px,
      $desktop-md: 8px
    );

    $font-size: (
      $mobile: 14px
    );

    $line-height: (
      $mobile: 20px
    );

    @include setStyleByBreakpoint('line-height', $line-height);
    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('flex-direction', $flex-direction);

    & > :first-child {
      $margin: (
        $above-desktop-xl: 0 32px 0 0,
        $desktop-md: 0 0 8px 0
      );

      @include setStyleByBreakpoint('margin', $margin);
    }
  }
}
</style>
